"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderParser = void 0;
const objects_1 = require("../objects");
const binary_data_parser_1 = require("./binary-data-parser");
/**
 * Parses the header data from the binary data.
 */
class HeaderParser extends binary_data_parser_1.BinaryDataParser {
    constructor(data) {
        super(data);
    }
    parse() {
        const magic = this.getUint32();
        if (magic != 0x4E787320) {
            return null;
        }
        return {
            version: this.getUint32(),
            verticesCount: this.getUint64(),
            facesCount: this.getUint64(),
            signature: this.readSignature(),
            nodesCount: this.getUint32(),
            patchesCount: this.getUint32(),
            texturesCount: this.getUint32(),
            sphere: this.readSphere()
        };
    }
    readSignature() {
        return {
            vertex: this.readVertex(),
            face: this.readFace(),
            flags: this.getUint32()
        };
    }
    readVertex() {
        const element = this.readElement();
        return new objects_1.NexusVertexAttributes(element[objects_1.VertexElementData.POSITION], element[objects_1.VertexElementData.NORMAL], HeaderParser.ensureColor(element[objects_1.VertexElementData.COLOR]), element[objects_1.VertexElementData.TEXTURE_COORDINATES], element[objects_1.VertexElementData.DATA]);
    }
    readFace() {
        const element = this.readElement();
        return new objects_1.NexusFaceAttributes(element[objects_1.FaceElementData.INDEX], element[objects_1.FaceElementData.NORMAL], HeaderParser.ensureColor(element[objects_1.FaceElementData.COLOR]), element[objects_1.FaceElementData.TEXTURE_COORDINATES], element[objects_1.FaceElementData.DATA]);
    }
    static ensureColor(color) {
        if (color) {
            const updateColorProperties = {
                type: objects_1.WebGlAttributes.UNSIGNED_BYTE_TYPE,
                glType: objects_1.WebGlAttributes.toWebGlAttribute(color.type)
            };
            Object.assign(color, updateColorProperties);
        }
        return color;
    }
    readElement() {
        return Array.from(Array(objects_1.AttributeConstants.ELEMENT_ATTRIBUTES_SIZE).keys()).map(() => this.readAttribute());
    }
    readAttribute() {
        const type = this.getUint8();
        const size = this.getUint8();
        if (!size) {
            return null;
        }
        const glType = objects_1.WebGlAttributes.toWebGlAttribute(type);
        const normalized = type < 7;
        const stride = objects_1.WebGlAttributes.toAttributeSize(type) * size;
        return new objects_1.NexusRenderAttribute(type, size, glType, normalized, stride);
    }
}
exports.HeaderParser = HeaderParser;
